import * as localDb from '../localDb/index.js';

export default async function getBackupInfo({fileData}) {
    try {
        return await localDb.peakInfo({fileData});
    } catch (error) {
        console.error(error);
        throw new Error(`Unable to backup current data`);
    }
}